import React from 'react';
import { PropTypes } from 'prop-types';
import { Button } from '@ontruck/orc';
import DateField from 'components/orders/Filters/Filters/Dates/DateField';

const FiltersBox = ({
  className,
  t,
  registerChild,
  handleApply,
  handleQuit,
  firstPickupTime,
  lastDropoffTime,
}) => (
  <div className={className} ref={registerChild}>
    <div className="fields-container">
      <DateField extraClassName="field-from" t={t} type="first_pickup_time" />

      <DateField extraClassName="field-to" t={t} type="last_dropoff_time" />
    </div>
    <div className="buttons-container">
      {firstPickupTime || lastDropoffTime ? (
        <div className="remove-btn">
          <Button
            nude
            size="XS"
            skin="secondary"
            text={t('remove_dates_filter')}
            onClick={handleQuit}
          />
        </div>
      ) : (
        <span />
      )}
      <Button size="XS" text={t('apply_dates_filter')} onClick={handleApply} />
    </div>
  </div>
);

FiltersBox.propTypes = {
  t: PropTypes.func,
  className: PropTypes.string,
  registerChild: PropTypes.func,
  handleApply: PropTypes.func,
  handleQuit: PropTypes.func,
  firstPickupTime: PropTypes.string,
  lastDropoffTime: PropTypes.string,
};

FiltersBox.defaultProps = {
  t: (t) => t,
  className: '',
  registerChild: () => {},
  handleApply: () => {},
  handleQuit: () => {},
  firstPickupTime: '',
  lastDropoffTime: '',
};

export default FiltersBox;
